import {
  LOADING_OVERVIEW,
  STOP_LOADING_OVERVIEW,
  CHANGE_DROPDOWN_OPTION,
  SET_ERRORS,
  SET_OVERVIEW,
  UPDATE_OVERVIEW,
} from '../types'
import { toast } from 'react-toastify'
import { handleError } from '../../utilities/errorHandler/errorHandler'

import 'react-toastify/dist/ReactToastify.css'
toast.configure()

// export const template = () => {
//     return  (dispatch, getState, { getFirebase, getFirestore }) => {
// const firebase = getFirebase()
// const firestore = getFirestore()
//     }
// }

export const updateOverview = (data) => {
  return {
    type: UPDATE_OVERVIEW,
    payload: data,
  }
}

export const changeDropdownOption = (dropdownOption) => {
  return {
    type: CHANGE_DROPDOWN_OPTION,
    payload: dropdownOption,
  }
}

export const getOverview = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    const id = getState().user.credentials.id
    if (!getState().overview.isInitiated) {
      dispatch({ type: LOADING_OVERVIEW })
      firestore
        .collection('Overviews')
        .doc(id)
        .get()
        .then((doc) => {
          const overview = doc.data()
          dispatch({
            type: SET_OVERVIEW,
            payload: overview,
          })
        })
        .catch((error) => {
          dispatch({ type: STOP_LOADING_OVERVIEW })
          handleError(error, dispatch, toast, SET_ERRORS)
        })
    } else {
      console.log('get overview not activated')
    }
  }
}


